import {HttpClient, HttpParams} from "@angular/common/http";
import {MessageService} from "./message.service";
import {Observable, of} from "rxjs";
// eslint-disable-next-line @typescript-eslint/naming-convention
import Config from "../../config/Config";
import {Favorite} from "../../models/Favorite";
import {inject, Injectable} from "@angular/core";

@Injectable({
	providedIn: "root",
})
export class HomescreenService {
	public http = inject(HttpClient);
	public messageService = inject(MessageService);

	getFavorites(): Observable<Favorite[]> {
		return this.http.get<Favorite[]>(Config.services.homescreen.baseUrl + Config.services.homescreen.favorites);
	}

	saveFavorites(favorites: Favorite[]): Observable<Favorite[]> {
		if (favorites === null || favorites === undefined || favorites.length === 0) {
			return of([]);
		}
		return this.http.post<Favorite[]>(
			Config.services.homescreen.baseUrl + Config.services.homescreen.favorites,
			favorites,
		) as Observable<Favorite[]>;
	}

	getMECData(selection, selectedType, bookingQuality, allDivisions): Observable<number> {
		let httpParams = new HttpParams()
			.set("selection", selection)
			.set("type", selectedType)
			.set("bookingQuality", bookingQuality)
			.set("allDivisions", allDivisions);
		return this.http.get<number>(Config.services.homescreen.baseUrl + Config.services.homescreen.mecData, {
			params: httpParams,
		});
	}

	getMEPData(businessUnit, selectedDivision, selectedType, date, calculationType): Observable<number> {
		let httpParams = new HttpParams()
			.set("businessUnit", businessUnit)
			.set("selectedDivision", selectedDivision)
			.set("type", selectedType)
			.set("date", date)
			.set("calculationType", calculationType);
		return this.http.get<number>(Config.services.homescreen.baseUrl + Config.services.homescreen.mepData, {
			params: httpParams,
		});
	}

	getLastImportDate() {
		return this.http.get<Date>(Config.services.homescreen.baseUrl + Config.services.homescreen.lastImportDate);
	}
}
